import { compact } from '@lglp/utils';

import { DocumentType } from '../../types/document';
import { and, attr } from '../algolia/algolia-filters-builder';

export const searchNewsroom = (): SearchNewsroomProps =>
  compact<SearchNewsroomProps>({
    hitsPerPage: 20,
    filters: and([
      attr('type', DocumentType.PRESS_RELEASE),
      attr('onNewsroom', 'true'),
    ]),
  });

type SearchNewsroomProps = {
  filters: string;
  hitsPerPage: number;
};
